import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CoreService } from 'src/app/shared/services/core.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-branding',
  imports: [RouterModule, CommonModule],
  template: `
    @if (options.logo != '') {
      <a [routerLink]="['/']">
        <img [src]="options.logo" class="align-middle mt-3" alt="logo" style="height: 35px;" />
      </a>
    }
  `
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}
}
